document.addEventListener("DOMContentLoaded", () => {
    const isGermany = document.documentElement.lang === "de-DE";
    const form = document.querySelector("#formclient");

    if (!isGermany || !form) return false;

    const regions = [
        { state: "Bremen", code: "HB", region: "North" },
        { state: "Schleswig-Holstein", code: "SH", region: "North" },
        { state: "Mecklenburg-Vorpommern", code: "MV", region: "North" },
        { state: "Brandenburg", code: "BB", region: "North" },
        { state: "Berlin", code: "BE", region: "North" },
        { state: "Hamburg", code: "HH", region: "North" },
        { state: "Sachsen-Anhalt", code: "ST", region: "North" },
        { state: "Niedersachsen", code: "NI", region: "North" },
        { state: "Baden-Württemberg", code: "BW", region: "North" },
        { state: "Nordrhein-Westfalen", code: "NW", region: "West" },
        { state: "Saarland", code: "SL", region: "West" },
        { state: "Hessen", code: "HE", region: "West" },
        { state: "Rheinland-Pfalz", code: "RP", region: "West" },
        { state: "Thüringen", code: "TH", region: "South" },
        { state: "Sachsen", code: "SN", region: "South" },
        { state: "Bayern", code: "BY", region: "South" },
    ];

    const zipData = (zip) => {
        fetch("https://api.zippopotam.us/DE/" + zip)
            .then((response) => response.json())
            .then((data) => storeRegion(data))
            .catch(() => {
                window.sessionStorage.setItem("outboundRegion", "North");
            });
    };

    const storeRegion = (places) => {
        const firstPlace = places && places.places && places.places[0];
        const code = firstPlace ? firstPlace["state abbreviation"] : "BB";

        regions.forEach(function (region) {
            region.code == code && window.sessionStorage.setItem("outboundRegion", region.region);
        });
    };

    new Promise(function (resolve) {
        if (window.sessionLayer) {
            window.sessionLayer.leadHandler.on("leadCreated", function () {
                resolve();
            });
        }
    }).then(() => {
        const leadData = window.sessionLayer.leadHandler.lead.lead;
        const { Phone, PostalCode, Age_of_current_hearing_aid__c } = leadData;
        const isYoungHAT = Age_of_current_hearing_aid__c == "1";

        if (!Phone) return false;

        isYoungHAT ? window.sessionStorage.setItem("outboundRegion", "Younghat") : zipData(PostalCode);
    });
});